export class Lookup
{
  smartcard: string;   
}


// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/models/lookupmodel.ts